import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../../Components/NavBar/NavBar";
import Footer from "../../Components/footer/Footer";
import FixedBar from "../../Components/fixedBar/FixedBar";




export default function BaseScreen() {
  return (
    <div>
    
    <header className="z-20" >
        <NavBar />
      </header>
      <main  className="">
        <Outlet  />
      </main>
      <footer className="md:mb-20">
        <Footer />
       <FixedBar className="hidden md:block"/>
      </footer>

  </div>
  )
}
